import React, { Component, Fragment } from "react";
import List from "material-ui/List";
import { withRouter } from "react-router";
import ListSubheader from "material-ui/List/ListSubheader";
import ViewModule from "material-ui-icons/ViewModule";
import GroupAdd from "material-ui-icons/GroupAdd";
import SupervisorAccount from "material-ui-icons/SupervisorAccount";
import NoteAdd from "material-ui-icons/NoteAdd";
import LocalGroceryStore from "material-ui-icons/LocalGroceryStore";
import Assessment from "material-ui-icons/Assessment";
import LocalAtm from "material-ui-icons/LocalAtm";
import More from "material-ui-icons/More";
import Block from "material-ui-icons/Block";
import MonetizationOn from "material-ui-icons/MonetizationOn";
import Wallet from "material-ui-icons/AccountBalanceWallet";
import Cap from 'material-ui-icons/KeyboardCapslock';
import HighlightOff from 'material-ui-icons/HighlightOff';
import AddBox from 'material-ui-icons/AddBox';
import MinusBox from 'material-ui-icons/IndeterminateCheckBox';
import { Home, PermPhoneMsg } from 'material-ui-icons';

import SidebarMenu from "../../controls/SidebarMenu";

class Menus extends Component {
  state = {};

  isSelected = path =>
    this.props.history.location.pathname === `/${path}` ||
    this.props.history.location.pathname.includes(`/${path}/`);

  onMenuClick = route => {
    this.props.history.push(route);
  };

  render() {
    return (
      <Fragment>
        <List>

        <SidebarMenu
            isSelected={
              this.isSelected("/") || this.isSelected("/")
            }
            onClick={() => this.onMenuClick("/")}
            text="Home"
            icon={<Home />}
          />


          <SidebarMenu
            isSelected={
              this.isSelected("expense") || this.isSelected("expensetypes")
            }
            onClick={() => this.onMenuClick("/expense")}
            text="Bill Receipting"
            icon={<LocalAtm />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("enquiry")
            }
            onClick={() => this.onMenuClick("/enquiry")}
            text="Remittance Enquiry/Cancellation"
            icon={<Block />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("float")
            }
            onClick={() => this.onMenuClick("/float")}
            text="Float Reimbursement"
            icon={<MonetizationOn />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("cheque")
            }
            onClick={() => this.onMenuClick("/cheque")}
            text="Cheque/Post Dated Entry"
            icon={<Wallet />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("cashTotal")
            }
            onClick={() => this.onMenuClick("/cashTotal")}
            text="Cash Totals at Maximum"
            icon={<Cap />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("closeCash")
            }
            onClick={() => this.onMenuClick("/closeCash")}
            text="Close Cash Receipting"
            icon={<HighlightOff />}
          />

          <ListSubheader>Setup</ListSubheader>
          
          <SidebarMenu
            isSelected={
              this.isSelected("cashAdd")
            }
            onClick={() => this.onMenuClick("/cashAdd")}
            text="Cash Add"
            icon={<AddBox />}
          />
          
          <SidebarMenu
            isSelected={
              this.isSelected("cashDrop")
            }
            onClick={() => this.onMenuClick("/cashDrop")}
            text="Cash Drop"
            icon={<MinusBox />}
          />

          <ListSubheader>MASTER</ListSubheader>

          <SidebarMenu
            isSelected={this.isSelected("customers")}
            onClick={() => this.onMenuClick("/customers")}
            text="Customers"
            icon={<GroupAdd />}
          />

          <SidebarMenu
            isSelected={
              this.isSelected("products") || this.isSelected("producttypes")
            }
            onClick={() => this.onMenuClick("/products")}
            text="Categories"
            icon={<More />}
          />

          <ListSubheader>REPORTS</ListSubheader>
          <SidebarMenu text="Todays Collection" icon={<Assessment />} 
            isSelected={
              this.isSelected("todayCollection")
            }
            onClick={() => this.onMenuClick("/todayCollection")}
          />
          <SidebarMenu text="Remittance Cancellation" icon={<LocalGroceryStore />} 
            onClick={() => this.onMenuClick("/cancellation")}
          />
          <SidebarMenu text="Bill Payment" icon={<LocalAtm />}
            onClick={() => this.onMenuClick("/billPayment")} 
          />
          
          <ListSubheader>APPLICATIONS</ListSubheader>
          <SidebarMenu text="CRM Portal" icon={<PermPhoneMsg />} 
            onClick={() => window.open("http://iwk.isoftstone.com.my/")
            }
          />
        </List>



        
      </Fragment>
    );
  }
}

export default withRouter(Menus);



// WEBPACK FOOTER //
// ./src/components/home/sidebar/Menus.js